import DashboardNavigation from './DashboardNavigation'
import Footer from './Footer'
import PolicyBlockedMessageBody from './PolicyBlockedMessageBody'
import { POLICY_REFERRAL_CUSTOMER_MESSAGE } from '../utils/policyReferralState'

type PolicyReferralBlockedProps = {
  /** Defaults to shared customer copy. */
  message?: string
  onBackToDashboard?: () => void
}

/**
 * Full-page block when a policy is in an Entsia referral state (no policy details or self-service).
 */
export default function PolicyReferralBlocked({
  message = POLICY_REFERRAL_CUSTOMER_MESSAGE,
  onBackToDashboard,
}: PolicyReferralBlockedProps) {
  return (
    <div className="bg-background-tertiary flex flex-col min-h-screen w-full">
      <DashboardNavigation />
      <div className="bg-background-brand-solid flex flex-col gap-0 items-center overflow-clip px-0 py-[32px] md:py-[48px] relative shrink-0 w-full">
        <div className="flex flex-col gap-0 items-center max-w-container-desktop px-[16px] md:px-[32px] py-0 relative shrink-0 w-full">
          {onBackToDashboard && (
            <button
              type="button"
              onClick={onBackToDashboard}
              className="cursor-pointer flex gap-[4px] items-center justify-center overflow-clip p-0 relative shrink-0 mb-4"
            >
              <span className="font-body font-semibold text-sm leading-sm text-text-primary-on-brand">
                Back to dashboard
              </span>
            </button>
          )}
        </div>
      </div>
      <main id="main" className="flex flex-col flex-1 w-full px-[16px] md:px-[32px] py-[40px] md:py-[64px] max-w-container-desktop mx-auto">
        <div className="bg-background-primary border border-border-primary border-solid flex flex-col gap-[16px] items-start px-[24px] py-[32px] relative rounded-2xl shadow-xs w-full max-w-[640px] mx-auto">
          <p className="font-display font-semibold text-display-xs leading-display-xs text-text-primary-900">
            We need to help you with this policy
          </p>
          <PolicyBlockedMessageBody
            message={message}
            className="font-body font-regular text-md leading-md text-text-secondary-700"
          />
          <p className="font-body font-semibold text-sm leading-sm text-text-primary-900">
            Call Club 4X4 on{' '}
            <a href="tel:1300296296" className="text-text-brand-secondary-700 underline">
              1300 296 296
            </a>
          </p>
        </div>
      </main>
      <Footer />
    </div>
  )
}
